export const breakpoints = {
  tablet: 768,
  desktop: 991,
  largeDesktop: 1200,
};
